import { useTranslation } from "react-i18next";

export function useTimeOfDay() {
  const { t } = useTranslation();

  const timeNow = new Date(Date.now()).getHours();

  let timeGreeting: string;

  if (timeNow < 12 && timeNow >= 1) {
    timeGreeting = t("Good morning");
  } else if (timeNow >= 12 && timeNow < 17) {
    timeGreeting = t("Good afternoon");
  } else {
    timeGreeting = t("Good evening");
  }
  return timeGreeting;
}
